import PropTypes from 'prop-types';
import { useCallback, useContext } from 'react';

import styles from './styles.module.scss';

import TextLayout from 'OK/components/layouts/content/text';
import ThemeContext from 'OK/util/context/theme';

export default function SolutionItem(props) {
  const { description, href, imageUrl, onClick: onClickProp, title } = props;

  const hasClickHandler = typeof onClickProp === 'function';
  const linkMode = typeof href === 'string';
  const clickable = hasClickHandler || linkMode;
  const theme = useContext(ThemeContext);

  const onClick = useCallback(
    (e) => {
      if (clickable) {
        if (!window.getSelection().isCollapsed) {
          // Cancel click because the user is highlighting text.
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        if (hasClickHandler) {
          onClickProp(e);
        } else {
          window.open(href, '_self');
        }
      }
    },
    [clickable, hasClickHandler, href, onClickProp]
  );

  return (
    <div className={styles.solutionItemContainer} onClick={onClick}>
      <div className={styles.solutionItemDetail}>
        <img
          alt='Solution item image'
          className={styles.solutionItemImage}
          src={imageUrl ? imageUrl : `/img/empty_media_${theme.name}.svg`}
        />
        <TextLayout>
          <span className={styles.solutionItemTitle}>{title}</span>
          <br />
          <span className={styles.solutionItemDescription} size='sm'>
            {description}
          </span>
        </TextLayout>
      </div>
      <img src='/icons/caret_link.svg' alt='Caret icon' />
    </div>
  );
}

SolutionItem.propTypes = {
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
};
